/** Apex domains where `brand.apex` is a manufacturer storefront (not the public landing host). */
const TENANT_PARENT_SUFFIXES = ["saddlefit.io"];

const RESERVED_SUBDOMAINS = new Set(["staging", "develop", "www"]);

/**
 * Manufacturer subdomain requested by the URL, or null for the main marketing site.
 * @param {string} hostname lowercased host without port
 * @returns {string | null}
 */
export function getManufacturerRequestedSubdomain(hostname) {
  const parts = hostname.split(".");

  if (hostname.includes("localhost")) {
    if (parts.length === 2 && !RESERVED_SUBDOMAINS.has(parts[0])) {
      return parts[0];
    }
    return null;
  }

  if (parts.length === 3) {
    const sub = parts[0];
    const parent = `${parts[1]}.${parts[2]}`;
    if (RESERVED_SUBDOMAINS.has(sub)) return null;
    if (TENANT_PARENT_SUFFIXES.includes(parent)) return sub;
  }

  return null;
}
